import ApiRequestManagerInstance from '../ApiRequestManager';
import DeviceConfig from '@devices/config';
import User from '../../classes/user';
import checkLoginRequest from './checkLoginRequest';
import { IDeviceRequest } from '../../types/interfaces/login';
import { setUser } from '../../store/slices/user.slice';
import { store } from '../../store/store';

export default function checkDeviceRequest(code: string) {
  const promise = new Promise<{ code: string; validated: boolean }>(
    async (resolve) => {
      try {
        const data = { idDevice: DeviceConfig.info.uuid, code };
        const response = (await ApiRequestManagerInstance.post({
          endpoint: {
            url: 'apiUrl',
            section: 'device',
            subsection: 'checkDevice',
          },
          data,
          headers: [{ header: 'Platform', value: 'SMARTTV' }],
        })) as unknown as IDeviceRequest;
        store.dispatch(setUser(User.fromRequest(response)));
        resolve({ code, validated: true });
        checkLoginRequest();
      } catch (e) {
        resolve({ code, validated: false });
      }
    }
  );

  return promise;
}
